const ynToBool = (value = false, defaultValue = false) => {
  const val = value !== undefined ? value : defaultValue;
  
  if (val === true || val === 1 || val === 'true' || val === '1') {
    return true;
  }
  return false;
};

export default ynToBool;
